import { useMemo } from "react";
import {
  getAccessRoles,
} from "../auth/tokenFunctions";
import { getAccessTokenFromStorage } from "../auth/tokenStorage";

export const useUserRoles = (): string[] => {
  return useMemo(() => {
    const token = getAccessTokenFromStorage();
    if (!token) {
      return [];
    }

    return getAccessRoles(token);
  }, []);
};
